import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/Button/Button.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.Button';
export {styles};